import {gql} from '@apollo/client'

export const ADDITIONAL_SEARCH_QUERY = gql`
  query additionalSearchQuery {
    client {
      id
      offices {
        id
        name
      }
      groups {
        id
        name
        parentGroupId
      }
      employeeConnections {
        employmentTypes {
          id
          name
        }
        occupations {
          id
          name
        }
        positions {
          id
          name
        }
      }
    }
  }
`

export interface AdditionalSearchQuery {
  client: {
    offices: Office[]
    groups: Group[]
    employeeConnections: {
      employmentTypes: EmploymentType[]
      occupations: Occupation[]
      positions: Position[]
    }
  }
}

export interface Office {
  id: string
  name: string
}

export interface EmploymentType {
  id: string
  name: string
}

export interface Group {
  id: string
  name: string
  parentGroupId?: string
}

export interface Occupation {
  id: string
  name: string
}

export interface Position {
  id: string
  name: string
}
